module.exports = __webpack_public_path__ + "static/img/1-1.045f154.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/1-1.png
// module id = hRc5
// module chunks = 0